export default "__VITE_ASSET__CB_rw8vn__"